var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.143,
    height: 26.747,
    viewBox: "0 0 23.143 26.747",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a02dfc69be13291199b39906b2abd737",
    d: "M6968.172,6976.773a5,5,0,1,0-4.908-5.09c0,.03,0,.06,0,.09a4.97,4.97,0,0,0,4.91,5Zm0,3.667c-3.845,0-11.454,1.916-11.454,5.833v7.247h23.143v-7.247c0-3.917-7.843-5.833-11.688-5.833Z",
    transform: "translate(-6956.718 -6966.773)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.634ad196d6f41e78b77d4367f6dfaac0.svg";
export { ForwardRef as ReactComponent };